import { getErrorMessage } from "./error_message";

// Raised by the bundler's own preload helper when a chunk's stylesheet side-car
// can't be fetched, so unlike the browser messages below it is stable across
// engines.
const CSS_PRELOAD_ERROR_PATTERN = "unable to preload css";

// A dynamic import() that can't fetch its hashed chunk rejects with a
// browser-specific message rather than a stable error type. Matching the full
// message is the only cross-browser way to tell a chunk-load miss (recoverable
// by reloading onto the current build) apart from a genuine application crash.
// Each pattern is a distinctive multi-word phrase to avoid matching unrelated
// errors that merely mention a chunk or a fetch.
const CHUNK_LOAD_ERROR_PATTERNS = [
  "failed to fetch dynamically imported module", // Chromium / V8
  "error loading dynamically imported module", // Firefox
  "importing a module script failed", // Safari / WebKit
  // Same missing-asset cause as a script miss and recoverable the same way, so
  // it belongs in the same group and earns the same reload affordance rather
  // than a generic crash screen.
  CSS_PRELOAD_ERROR_PATTERN,
];

// A missing stylesheet, unlike a missing script, has a usable fallback: the page
// can still render, just unstyled. Callers that can act on that difference need
// to tell it apart from the script cases.
export function isCssPreloadError(error: unknown): boolean {
  return getErrorMessage(error)
    .toLowerCase()
    .includes(CSS_PRELOAD_ERROR_PATTERN);
}

export function isChunkLoadError(error: unknown): boolean {
  // Bundlers tag their generated loader's failures with this error name, which
  // is more reliable than its (localized, version-varying) message text.
  if (error instanceof Error && error.name === "ChunkLoadError") {
    return true;
  }

  const normalized = getErrorMessage(error).toLowerCase();

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) =>
    normalized.includes(pattern)
  );
}
